import React from "react";

import StreakSaveAppliedModal from "./StreakSaveAppliedModal";

export default function StreakSaveAppliedModalContainer({ context, onHidden }) {
  if (!context) return null;

  return (
    <StreakSaveAppliedModal
      currentBalance={context.currentBalance}
      currentStreakDays={context.currentStreakDays}
      daysSinceLastSession={context.daysSinceLastSession}
      ackUrl={context.ackUrl}
      savedDate={context.savedDate}
      onHidden={onHidden}
    />
  );
}
